export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/identification_perseus/go_with_activation.64d2852.png";